import { useState, useEffect, useContext } from 'react';
import InputDetail from '../input/detail-input';
import CONSTANT from '../../../Constant/Constant';
import { Tooltip, Typography } from '@mui/material';
import { DirectionContext } from '../../../context/DirectionProvider';
import translationConfig from '../../../config/WeglotLanguageTranslation.json';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import UpdateIcon from '@mui/icons-material/Update';

const SingleValue = (props) => {
    const [value, setValue] = useState(props.value);
    const [label, setLabel] = useState(props.label);
    const [error, setError] = useState(false);
    const direction = useContext(DirectionContext);
    const excludeLabel = translationConfig?.labelExclusionList?.includes(label?.toLowerCase());
    useEffect(() => {
        setLabel(props.label);
        setValue(props.value);
        setError(props.error);
    }, [props.label, props.value, props.error])


    /**
     *  Handles Multiple Values from array and joins them into single string seprated by commas.
     * @param {*} input 
     * @returns 
     */

    function extractValues(input) {
        // Normalize input to array
        const arr = Array.isArray(input) ? input : [input];

        // Extract the "value" field safely
        const result = arr
            .map(item => item?.value)
            .filter(v => v); // Remove null/undefined

        return result.join(', ');
    }

    /**
     * check value is date or not
     * @param {*} dateString 
     * @returns flag 
     */
    const isDate = (dateString) => {
        // if (isNaN(dateString) && !isNaN(Date.parse(dateString)) && label !== 'Address Line1')
        //     return true;
        // else
        return false;
    }

    /**
     * Pass values to parent component
     * @param {*} value 
     * @param {*} flag 
     */
    const passToParent = (value, flag) => {
        props.updatedValue(value, flag);
    }
    return (
        <>
            {
                value !== undefined && props.label !== 'Source Address ID' && value.map((detail, i) => {
                    return (
                        <div key={'detail' + i} id="details-text">
                            <Typography variant='p'>
                                <span dir={direction} className={`text-dark mb-2 mt-2 ${excludeLabel?'_wg-exclude': ''}`}>
                                        {
                                            label + (
                                                (props.mode !== undefined &&
                                                    props.mode === 'Edit' &&
                                                    (CONSTANT.REQUIRED.includes(label) || props.requiredAddress !== undefined))
                                                    ? ' * ' : '') + ':'
                                        }
                                        &nbsp;
                                </span>
                                <span 
                                    dir={direction}
                                    className={(props?.label === "Effective End Date" && props?.oldEffectiveEndDate) || (['Active Flag', 'Effective End Date'].includes(props?.label) && detail['value'].split(' ')[1] == String.fromCharCode(10142)) ? 'text-muted _wg-exclude italic' : 'text-muted _wg-exclude'}
                                >
                                    <span 
                                        style={{ textDecoration: detail?.dcr_status == 'CHANGE_MODIFIED' ? 'line-through' : 'none' }}
                                    >
                                        {
                                            (props.mode === undefined || props.mode === 'viewing') && (
                                                props?.label === "Effective End Date" && 
                                                props?.oldEffectiveEndDate && 
                                                props?.existingAddessFlagState ? 
                                                `${props?.oldEffectiveEndDate} ` + String.fromCharCode(10142) + ` ${detail.value}` : 
                                                detail.value || ''
                                            )                                       
                                            // (detail?.dcr_status == null ? '' : detail?.dcr_status)
                                        }                                     
                                    </span>
                                    {
                                        detail?.dcr_status && detail?.dcr_status == 'CHANGE_MODIFIED' &&
                                            <span className='text-muted' style={{ paddingLeft: '10px' }}>{detail?.final_value || ''}</span>
                                    }
                                </span>
                                <span className='status' style={{alignContent: 'flex-end', paddingLeft: '10px'}} >
                                    {
                                        detail?.dcr_status == 'CHANGE_MODIFIED' ?
                                        <Tooltip disableFocusListener title="Change Modified" id="tooltip">
                                            <UpdateIcon color='warning'/>
                                        </Tooltip>
                                        : detail?.dcr_status == 'CHANGE_REJECTED' ? <Tooltip disableFocusListener title="Change Rejected" id="tooltip"><CancelIcon color= 'error'/></Tooltip> : detail?.dcr_status == 'CHANGE_ACCEPTED' ? <Tooltip disableFocusListener title="Change Accepted" id="tooltip" ><CheckCircleIcon color='success'/></Tooltip> : ''}
                                </span>
                            </Typography>
                            {
                                props.mode === 'Edit' &&
                                <InputDetail
                                    error={error}
                                    date={isDate(detail.value)}
                                    type={'text'}
                                    value={detail.value} label={label}
                                    updatedValue={(newValue, flag) => passToParent(newValue, flag)}
                                    newValue={props.newValue}
                                    entity = {props.entity}
                                    sourceName={props.source}
                                />
                            }
                        </div >)
                })
            }
            {
                value !== undefined && props.label === 'Source Address ID' &&

                <div id="details-text">
                    <Typography variant='p'>
                        <span dir={direction} className={`text-dark mb-2 mt-2 ${excludeLabel ? '_wg-exclude' : ''}`}>
                            {
                                label + (
                                    (props.mode !== undefined &&
                                        props.mode === 'Edit' &&
                                        (CONSTANT.REQUIRED.includes(label) || props.requiredAddress !== undefined))
                                        ? ' * ' : '') + ':'
                            }
                            &nbsp;
                        </span>
                        <span
                            dir={direction}
                            className={'text-muted _wg-exclude'}
                        >
                            <span
                                style={{ textDecoration: 'none' }}
                            >
                                {
                                    (props.mode === undefined || props.mode === 'viewing') && (
                                        extractValues(value) || ''
                                    )
                                }
                            </span>

                        </span>
                    </Typography>
                </div >
            }
            {
                value === undefined && props.mode === 'Edit' && props.addFlag === undefined &&
                <div >
                    <span className="text-muted mb-2  mt-2">{
                        label + (
                            (props.mode !== undefined &&
                                props.mode === 'Edit' &&
                                (CONSTANT.REQUIRED.includes(label) || props.requiredAddress !== undefined))
                                ? ' * ' : '') + ':'
                    }</span>

                    {
                        props.mode === 'Edit' &&
                        <InputDetail date={isDate(value)}
                            error={error}
                            type={'text'}
                            label={label}
                            updatedValue={(newValue, flag) => passToParent(newValue, flag)}
                            newValue={props.newValue}
                            entity = {props.entity}
                            sourceName={props.source}
                        />
                    }
                </div >
            }

        </>
    );
}

export default SingleValue;